import { Route } from '@angular/router';
import { DeviceSelectionComponent } from '@features/activity-types/order-accessories/device-selection/device-selection.component';
import { AccessoriesComponent } from '@features/shopping/accessories/accessories.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const order_accessories_routes: Route[] = [
  {
    path: 'device-selection',
    component: DeviceSelectionComponent,
    title: 'Select Device',
    data: { order_type_id: 14 }
  },
  {
    path: 'accessories',
    component: AccessoriesComponent,
    title: 'Get Add Ons',
    data: { order_type_id: 14 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 14 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 14 }
  },
  {
    path: '',
    redirectTo: 'device-selection',
    pathMatch: 'full'
  }
];
